var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticStyle:{"margin-top":"16vh"}},[_c('van-empty',{attrs:{"image":"error","description":"您无权限访问，请联系管理员"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }